import { memo } from "react";

// styles
import { StyledScanViewerTagMenu } from "./StyledScanViewerTagMenu";

// react icons
import { IoClose } from "react-icons/io5";

// i18n
import { useTranslation } from "react-i18next";

// 標籤選單
// 環物物件的標籤只會釘在其中一張照片上，使用者一旋轉就看不到 marker，也就不知道有標籤可點。
// 這個選單把所有標籤列出來，點一下就轉到該標籤所在的那張並展開它。
//
// items 是 [{ tag, serialNumber }]，serialNumber 一定要沿用原始索引 + 1，
// 才會跟畫面上 marker 的編號（Image360 用 tags 陣列的 index + 1）對得起來。
const ScanViewerTagMenu = ({
  items,
  imageList,
  open,
  currentIndex,
  dragging,
  fullscreen,
  onClose,
  onSelect,
}) => {
  const { t } = useTranslation();

  // 抽屜是蓋在 Image360 上方的浮層，不擋掉滑鼠／觸控事件的話，在清單上滑動會把物件轉走
  const stopEvent = (e) => e.stopPropagation();

  return (
    <StyledScanViewerTagMenu
      $open={open}
      $dragging={dragging}
      $fullscreen={fullscreen}
      onMouseDown={stopEvent}
      onMouseMove={stopEvent}
      onMouseUp={stopEvent}
      onMouseLeave={stopEvent}
      onDragStart={stopEvent}
      onTouchStart={stopEvent}
      onTouchMove={stopEvent}
      onTouchEnd={stopEvent}
      onClick={stopEvent}
      onWheel={stopEvent}
    >
      <div className="menuHeader">
        <span>{t("scankitViewer.tagList", { total: items.length })}</span>
        <button
          type="button"
          className="menuClose"
          aria-label={t("scankitViewer.closeTagList")}
          onClick={onClose}
        >
          <IoClose />
        </button>
      </div>
      <ul className="menuList">
        {items.map(({ tag, serialNumber }) => {
          return (
            <li key={tag.id ?? serialNumber}>
              <button
                type="button"
                className="menuItem"
                // 這個標籤就在目前這張畫面上，用左側橘色邊條標出來，
                // 直接回答「我轉到這個角度，畫面上有沒有東西可以點」
                data-current={tag.scankitIndex === currentIndex}
                onClick={() => onSelect(serialNumber, tag)}
              >
                <span className="menuBadge">{serialNumber}</span>
                <span className="menuTitle">
                  {tag.title || t("scankitViewer.untitledTag", { number: serialNumber })}
                </span>
                {/* 縮圖用的是 Image360 掛載時已經預載的同一批照片，不會多發請求 */}
                <span className="menuThumbnail">
                  <img src={imageList[tag.scankitIndex]} alt="" />
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </StyledScanViewerTagMenu>
  );
};

export default memo(ScanViewerTagMenu);
